import React, { useEffect, useState } from "react";
import api from "../../api/api";
import Create from "./Create";
import Edit from "./Edit";
import Alerts from "../Alerts";
import { CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const View = () => {
  const [cards, setCards] = useState("");
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [item, setItem] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [warning, setWarning] = useState({});

  useEffect(() => {
    // A função só será executada quando `cards` for uma string vazia.
    if (cards !== "") return;
    const fetchFeaturedProducts = async () => {
      try {
        const response = await api.get("/categoriesFeatured");
        setFeaturedProducts(response.data.categoryFeaturedProduct);
      } catch (error) {
        console.error("Erro ao buscar produtos destacados:", error);
        setWarning({
          type: "error",
          message: "Falha ao carregar os cards do servidor!",
        });
        handleOpenSnackbar();
      }
    };
    const fetchCategories = async () => {
      try {
        const response = await api.get("/categories/nested");
        setCategories(response.data.categories);
      } catch (error) {
        console.error("Erro ao buscar categorias:", error);
        setWarning({
          type: "error",
          message: "Falha ao carregar as categorias do servidor!",
        });
        handleOpenSnackbar();
      }
    };

    fetchCategories();
    fetchFeaturedProducts();
  }, [cards]);

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <div className="p-4">
      <div className="flex justify-start mb-8">
        <button
          onClick={() => {
            cards === "" ? setCards("create") : setCards("");
          }}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 transition-colors flex items-center gap-2"
        >
          {cards === "" ? (
            <div className="flex items-center gap-2">
              <AddIcon sx={{ fontSize: 18, color: "white" }} />
              Criar Destaque
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <ArrowBackIcon sx={{ fontSize: 18, color: "white" }} />
              Voltar
            </div>
          )}
        </button>
      </div>

      {cards === "create" ? (
        <Create
          setWarning={setWarning}
          handleOpenSnackbar={handleOpenSnackbar}
          setCards={setCards}
        />
      ) : cards === "edit" ? (
        <Edit
          setWarning={setWarning}
          handleOpenSnackbar={handleOpenSnackbar}
          item={item}
          setCards={setCards}
        />
      ) : featuredProducts.length > 0 && categories.length > 0 ? (
        <div className="space-y-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {featuredProducts.map((featured, index) => {
              const category = categories.find(
                (c) => c.id === featured.categoryId
              );

              return (
                <div
                  key={index}
                  className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 h-full flex flex-col"
                >
                  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 border-b border-gray-200">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                      <div className="flex-1">
                        <h2 className="text-2xl font-bold text-gray-800 mb-2">
                          Categoria:{" "}
                          {category
                            ? category.name
                            : "Categoria Não Encontrada"}
                        </h2>
                        <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-medium">
                            ID da Categoria: {featured.categoryId}
                          </span>
                          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full font-medium">
                            {featured.viewProducts?.length || 0} Produtos
                          </span>
                        </div>
                      </div>
                      <button
                        onClick={() => {
                          setCards("edit");
                          setItem(featured);
                        }}
                        className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all duration-200 flex items-center gap-2 shadow-md hover:shadow-lg"
                      >
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          />
                        </svg>
                        Editar Card
                      </button>
                    </div>
                  </div>

                  <div className="p-8 flex-1 flex flex-col">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 flex-1">
                      {featured.viewProducts?.map((product, productIndex) => (
                        <div
                          key={productIndex}
                          className="group relative bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 hover:border-blue-300 h-full flex flex-col"
                        >
                          <div className="flex-1 overflow-hidden bg-gray-50">
                            <img
                              src={product.imgSrc}
                              alt={product.imgAlt || product.name}
                              className="w-full h-64 object-contain object-center group-hover:scale-105 transition-transform duration-300"
                              onError={(e) => {
                                e.target.src =
                                  "https://via.placeholder.com/300x300?text=Imagem+não+disponível";
                              }}
                            />
                          </div>

                          <div className="p-4 flex-1 flex flex-col">
                            <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2 flex-1">
                              {product.name}
                            </h3>

                            {product.actionText && (
                              <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                                {product.actionText}
                              </p>
                            )}

                            <div className="flex items-center justify-between mt-auto">
                              <a
                                href={product.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors duration-200"
                              >
                                Ver Produto →
                              </a>
                              <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                #{productIndex + 1}
                              </span>
                            </div>
                          </div>

                          <div className="absolute inset-0 bg-blue-600 bg-opacity-0 group-hover:bg-opacity-5 transition-all duration-300 pointer-events-none" />
                        </div>
                      ))}
                    </div>

                    {(!featured.viewProducts ||
                      featured.viewProducts.length === 0) && (
                      <div className="text-center py-8 flex-1 flex items-center justify-center">
                        <div className="text-gray-400 mb-4">
                          <svg
                            className="w-16 h-16 mx-auto"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={1}
                              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                            />
                          </svg>
                        </div>
                        <p className="text-gray-500 text-lg">
                          Nenhum produto encontrado neste destaque
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-64">
          <CircularProgress size={60} />
          <p className="mt-4 text-gray-600">Carregando destaques...</p>
        </div>
      )}

      <Alerts
        open={openSnackbar}
        handleClose={handleCloseSnackbar}
        type={warning.type}
        message={warning.message}
      />
    </div>
  );
};

export default View;
